// extracted by mini-css-extract-plugin
export default {"root":"Tickets_root__YtFNS","cards":"Tickets_cards__xcRME","card":"Tickets_card__-ABjV","label":"Tickets_label__9hLX4"};